import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Grid, Stack } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { AppImages } from "app/appImages";
import { MprcLink } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { PublicationType } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import { useModalUserProfile } from "providers/UserProfileProvider";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { CardContextLink } from "views/knowledge/components/card/CardContextLink";

///
export const ContentPageAuthor = () => {
    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");
    const navigate = useNavigate();
    const location = useLocation();
    const { showUser } = useModalUserProfile();

    const actionName = pub.isDraft
        ? t("Feed.Card.Common.SaveDraftOnText")
        : pub.contentModifiedDate?.getTime() != pub.createdOn.getTime() && pub.supervisor == null
            ? t("Feed.Card.Common.ModifiedOnText")
            : pub.contentModifiedDate?.getTime() != pub.createdOn.getTime() && pub.supervisor != null
                ? t("Feed.Card.Common.EditedOnText")
                : pub.publicationType == PublicationType.Question
                    ? t("Feed.Card.Common.AskedOnText")
                    : pub.publicationType == PublicationType.Answer
                        ? t("Feed.Card.Common.AnsweredhOnText")
                        : t("Feed.Card.Common.PublishOnText");

    const actionDate = pub.isDraft
        ? pub.createdOn
        : pub.contentModifiedDate != pub.createdOn
            ? pub.contentModifiedDate
            : pub.createdOn;

    const avatarImg = pub.institutional != null
        ? pub.institutional.thumbnailUrl ?? AppImages.KnowledgeInstitutionalThumbnail
        : pub.author.thumbnailUrl;

    const authorName = pub.institutional != null
        ? pub.institutional.name
        : pub.isAnonymous
            ? t("Feed.Card.Common.AnonymousAuthorName")
            : pub.author.name;

    const RenderAuthorName = (
        <MprcFeedTypography variant="authorPrimary" component="div" noWrap>
            <span title={authorName}>{authorName}</span>
            {
                pub.supervisor != null &&
                <span> ({t("Feed.Card.Common.EditedBySupervisorText")})</span>
            }
        </MprcFeedTypography>
    );

    return (
        <>
            <Grid container justifyContent="center" alignItems="center" spacing={1} width="100%">
                {!pub.isAnonymous &&
                    <Grid>
                        {pub.institutional != null
                            ? <Avatar src={avatarImg} title={authorName} />
                            : <Avatar
                                className={AppGlobalClassKeys.clickable}
                                title={authorName}
                                src={avatarImg}
                                onClick={
                                    () => showUser(
                                        pub.author.userId,
                                        () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                                    )
                                }
                            />
                        }
                    </Grid>
                }
                <Grid size="grow" overflow="hidden">
                    <Stack direction="row" alignItems="center" gap={0.5}>
                        {
                            (pub.institutional != null || pub.isAnonymous)
                                ? RenderAuthorName
                                : (
                                    <MprcLink
                                        width="100%"
                                        onClick={
                                            () => showUser(
                                                pub.author.userId,
                                                () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                                            )
                                        }
                                    >
                                        {RenderAuthorName}
                                    </MprcLink>
                                )
                        }
                    </Stack>
                    <MprcFeedTypography variant="authorSecondary" component="div" noWrap>
                        <span>{actionName} {Formaters.relativeTime(actionDate)}</span>
                        {
                            !pub.isDraft && pub.channel?.name &&
                            <>
                                <span>&nbsp;{t("shared:Literal.At")}&nbsp;</span>
                                <CardContextLink
                                    publicationId={pub.publicationId}
                                    to={KnowledgePaths.FeedChannel(pub.channel.id)}
                                >
                                    <b>{pub.channel.name}</b>
                                </CardContextLink>
                            </>
                        }
                        {pub.isPrivate &&
                            <MprcFeedTypography variant="authorPrimary" component="span" ml={1}>
                                <FontAwesomeIcon icon={faLock} title={t("Feed.Card.Common.PrivateTooltip")} />
                            </MprcFeedTypography>
                        }
                    </MprcFeedTypography>
                </Grid>
            </Grid>
        </>
    );
};
